export const ASSIGN_ACTION_NAME = 'fsm.action.assign';
export const INITIAL_TRANSITION_ACTION_NAME = 'fsm.invoke.initial';
export const DONE_TRANSITION_ACTION_NAME = 'fsm.invoke.done';
export const ERROR_TRANSITION_ACTION_NAME = 'fsm.invoke.error';
export const EVENTLESS_TRANSITION_ACTION_NAME = 'fsm.invoke.eventless';
export const DEFAULT_CONTEXT = {};
export const DEFAULT_GUARDS = {};
